import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { map, pickBy } from 'lodash';
import { Link } from 'react-router-dom';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import * as moment from 'moment';
import TablePaginationActions from '../TablePagination'
import { deleteCampaign } from './CampaignOperation';
import Dialog from '../Dialog';
import WidgetCodeDialog from './widgetCodeDialog';

const styles = theme => ({
  cell: {
    border: 'none',
    paddingTop: 12,
    paddingBottom: 12
  },
  roundBtn: {
    height: 40,
    width: 40,
    boxShadow: 'none'
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  idBg:{
    backgroundColor: '#fddbe9',
    padding: '10px 22px',
    display: 'inline-block',
    whiteSpace: 'nowrap'
  }
});

export interface Iprops {
  classes: any;
  campaigns: any;
  deleteAction: (id) => void;
  fullWidth: Boolean;
  donations: any; 
}

export interface Istate {
  page: number;
  rowsPerPage: number;
  open: boolean;
  openWidget: boolean;
  sort:'asc' | 'desc';
  campaignsArr: any[];
  id: string;
}

class CampaignsTable extends React.Component<Iprops, Istate> {
  constructor(props) {
    super(props);
    this.state ={
      page: 0,
      rowsPerPage: 5,
      open: false,
      openWidget: false,
      sort:'asc',
      campaignsArr: Object.keys(props.campaigns || {}).map(i => props.campaigns[i]),
      id: ''
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if( prevProps.campaigns === undefined && this.props.campaigns !== undefined && JSON.stringify(this.props.campaigns) !==  JSON.stringify({}) && this.state.campaignsArr.length ===0) {
      const campaignsArr= Object.keys(this.props.campaigns || {}).map(i => this.props.campaigns[i]);
      this.setState({campaignsArr});
    }
  }
  
  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleClickOpen = (id) => {
    this.setState({ open: true, id });
  };

  handleClickWidgetOpen = (id) => {
    this.setState({ openWidget: true, id });
  };

  handleClose = () => {
    this.setState({ open: false, openWidget: false });
  };
  sortData = () => {
    const { sort, campaignsArr } = this.state;
    campaignsArr.sort((a , b) => {
      const aTime:any = new Date(a.timestamp);
      const bTime:any = new Date(b.timestamp);

      return sort === 'asc'?  bTime - aTime : aTime - bTime;
    })
    this.setState(prevState => (
        {sort: prevState.sort === 'asc' ? 'desc' : 'asc'}
    ))
  }
  render() {
    const { classes, campaigns, deleteAction, fullWidth, donations } = this.props;
    const { rowsPerPage, page, sort, campaignsArr, id, open, openWidget } = this.state;
    const uids= Object.keys(campaigns || {});
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, uids.length - page * rowsPerPage);
    return (
      <div>
        <Table padding="checkbox">
          <TableHead>
            <TableRow>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">ID</Typography></TableCell>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">NAME</Typography></TableCell>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">TOTAL DONATIONS</Typography></TableCell>
              <TableCell
                className={!fullWidth ?classes.cell: ''}
                sortDirection={sort}
              >
                <TableSortLabel
                  active={true}
                  direction={sort}
                  onClick={this.sortData}
                >
                  <Typography variant="title">CREATED DATE</Typography>
                </TableSortLabel>
              </TableCell>
              {fullWidth && <TableCell><Typography variant="title">ACTIONS</Typography></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {campaignsArr.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map (({ name, charities, timestamp }, index) => {
              const id = (page * rowsPerPage) + index;
              let totalDonations = 0;
              map(donations, (donation: any) => {
                // debugger;
                const { campaignId, type, timestamp:time } = donation;
                if(campaignId && campaignId === uids[id]) {
                  let amount = donation.amount || 0;
                  if(amount && amount.includes('£')) {
                    amount = amount.substring(1);
                  }
                  if(amount && type  === 'monthly') {
                    const noOfMonths = moment(moment()).diff(time, "months");
                    amount = parseInt(amount) + (parseInt(amount) * noOfMonths);
                  }
                  totalDonations += parseInt(amount);
                }
              })
              return (
                <TableRow key={uids[id]}>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2" >
                      <div className={classes.idBg}>
                      {uids[id]}
                      </div>
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2">
                      {name}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2">
                      {`£ ${totalDonations}`}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2">
                      {timestamp && moment(timestamp).format('DD MMM YYYY')}
                    </Typography>
                  </TableCell>
                  {fullWidth && <TableCell className={classes.cell}>
                    <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                      <Link to={`campaigns/edit/${uids[id]}`} >
                        <Button variant="fab"  className={classes.roundBtn}>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button variant="fab" color="default" className={classes.roundBtn} onClick={() => this.handleClickOpen(uids[id])}>
                        <DeleteIcon />
                      </Button>
                      <Button
                        variant="fab"
                        color="default"
                        className={classes.roundBtn}
                        onClick={() => this.handleClickWidgetOpen(uids[id])}
                      >
                        <VisibilityIcon />
                      </Button>
                    </div>
                  </TableCell>}
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
                <TableRow style={{ height: 60 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
 
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={12}
                count={uids.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                ActionsComponent={TablePaginationActions}
                rowsPerPageOptions={[]}
              />
            </TableRow>
          </TableFooter>
        </Table>
        <Dialog 
          open={open} 
          handleClose={this.handleClose} 
          action={() => deleteAction(id)} 
        />
        <WidgetCodeDialog
          open={openWidget}
          id={id}
          campaignType={campaigns && campaigns[id] ? campaigns[id].charities.campaignType : undefined}
          type={(campaigns && campaigns[id])
            ? (campaigns[id].charities ? campaigns[id].charities.widgetType : campaigns[id].widgetType) 
            : ''}
          handleClose={this.handleClose} 
        />
      </div>
    );
  }
}

function mapStateToProps({ campaigns, donations, auth:{ charityKey, isAdmin } }: any) {

  const campaignsData = campaigns.all;
  const donationsData = donations.all;
  if (!isAdmin && !charityKey) return { donations : {}, campaigns: {} };

  if (!isAdmin && charityKey) {
    const pickedCampaigns = pickBy(campaignsData, campaign => campaign.charities.hasOwnProperty(charityKey) && campaign.charities[charityKey]);
    const pickedDonations = pickBy(donationsData, donation  => donation.selectedCharityId === charityKey || donation.charityId === charityKey);
    return {
      campaigns: pickedCampaigns,
      donations: pickedDonations
    }
  }
  return {
    campaigns: campaignsData,
    donations: donationsData
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    deleteAction: (uid: string) => dispatch(deleteCampaign(uid))
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CampaignsTable));